"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const react_1 = __importStar(require("react"));
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const qrcode_react_1 = __importDefault(require("qrcode.react"));
const browser_utils_1 = require("@walletconnect/browser-utils");
const Modal = ({ uiOptions, uri, close }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const [checkMobile] = react_1.useState(() => browser_utils_1.isMobile());
    const [checkAndroid] = react_1.useState(() => browser_utils_1.isAndroid());
    const navigateToAppURL = react_1.useMemo(() => {
        if (checkMobile) {
            if (checkAndroid) {
                // Save the mobile link.
                browser_utils_1.saveMobileLinkInfo({
                    name: "Keplr",
                    href: "intent://wcV1#Intent;package=com.chainapsis.keplr;scheme=keplrwallet;end;",
                });
                return `intent://wcV1?${uri}#Intent;package=com.chainapsis.keplr;scheme=keplrwallet;end;`;
            }
            else {
                // Save the mobile link.
                browser_utils_1.saveMobileLinkInfo({
                    name: "Keplr",
                    href: "keplrwallet://wcV1",
                });
                return `keplrwallet://wcV1?${uri}`;
            }
        }
    }, [checkAndroid, checkMobile, uri]);
    react_1.useEffect(() => {
        // Try opening the app without interaction.
        if (navigateToAppURL) {
            window.location.href = navigateToAppURL;
        }
    }, [navigateToAppURL]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (_a = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.backdrop) === null || _a === void 0 ? void 0 : _a.className, style: Object.assign(Object.assign({}, (((_b = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.backdrop) === null || _b === void 0 ? void 0 : _b.disableDefaultStyle) ? {}
                : {
                    position: "fixed",
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: "rgba(0,0,0,0.1)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                })), (_c = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.backdrop) === null || _c === void 0 ? void 0 : _c.style), onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                close();
            } },
            react_1.default.createElement("div", { className: (_d = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.modalContainer) === null || _d === void 0 ? void 0 : _d.className, style: Object.assign(Object.assign({}, (((_e = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.modalContainer) === null || _e === void 0 ? void 0 : _e.disableDefaultStyle) ? {}
                    : {
                        padding: 20,
                        borderRadius: 10,
                        backgroundColor: "#DDDDDD",
                    })), (_f = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.modalContainer) === null || _f === void 0 ? void 0 : _f.style), onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                } }, !checkMobile ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("h3", { className: (_g = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.modalHeader) === null || _g === void 0 ? void 0 : _g.className, style: Object.assign(Object.assign({}, (((_h = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.modalHeader) === null || _h === void 0 ? void 0 : _h.disableDefaultStyle) ? {}
                        : {
                            fontSize: 20,
                            margin: 0,
                            marginBottom: 10,
                        })), (_j = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.modalHeader) === null || _j === void 0 ? void 0 : _j.style) }, "Scan QR Code"),
                react_1.default.createElement("div", { className: (_k = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.qrCodeContainer) === null || _k === void 0 ? void 0 : _k.className, style: (_l = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.qrCodeContainer) === null || _l === void 0 ? void 0 : _l.style },
                    react_1.default.createElement(qrcode_react_1.default, { size: (uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.qrCodeSize) || 500, value: uri })))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("h3", { className: (_m = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.modalHeader) === null || _m === void 0 ? void 0 : _m.className, style: Object.assign(Object.assign({}, (((_o = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.modalHeader) === null || _o === void 0 ? void 0 : _o.disableDefaultStyle) ? {}
                        : {
                            fontSize: 20,
                            margin: 0,
                            marginBottom: 10,
                        })), (_p = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.modalHeader) === null || _p === void 0 ? void 0 : _p.style) }, "Open App"),
                react_1.default.createElement("div", { className: (_q = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.appButtonContainer) === null || _q === void 0 ? void 0 : _q.className, style: (_r = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.appButtonContainer) === null || _r === void 0 ? void 0 : _r.style },
                    react_1.default.createElement("button", { className: (_s = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.appButton) === null || _s === void 0 ? void 0 : _s.className, style: (_t = uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.appButton) === null || _t === void 0 ? void 0 : _t.style, onClick: () => {
                            if (navigateToAppURL) {
                                window.location.href = navigateToAppURL;
                            }
                        } }, "Open App"))))))));
};
exports.Modal = Modal;
//# sourceMappingURL=modal.js.map